module.exports = __webpack_public_path__ + "static/media/work_in_progress.f2ff79b8.jpg";